import { ECategory } from '../types/recommendation';

export enum FOfferType {
  /**
   * Do not use
   */
  Unexpected = 0,
  /**
   * Квартира во вторичке
   */
  FlatOld = 1 << 1,
  /**
   * Квартира в новостройке
   */
  FlatNew = 1 << 2,
  /**
   * Квартира
   */
  Flat = FlatOld | FlatNew,
  /**
   * Доля
   */
  FlatShared = 1 << 3,
  /**
   * Комната
   */
  Room = 1 << 4,
  /**
   * Койко-место
   */
  Bed = 1 << 5,
  /**
   * Жилая городская
   */
  Urban = Flat | FlatShared | Room | Bed,
  /**
   * Дом/дача
   */
  House = 1 << 6,
  /**
   * Часть дома
   */
  HousePart = 1 << 7,
  /**
   * Таунхаус
   */
  Townhouse = 1 << 8,
  /**
   * Участок
   */
  Land = 1 << 9,
  /**
   * Загородная
   */
  Suburban = House | HousePart | Townhouse | Land,
  /**
   * Жилая
   */
  Residential = Urban | Suburban,
  /**
   * Офис
   */
  Office = 1 << 10,
  /**
   * Торговая площадь
   */
  TradeArea = 1 << 11,
  /**
   * Склад
   */
  Warehouse = 1 << 12,
  /**
   * ПСН
   */
  FreeAppointmentObject = 1 << 13,
  /**
   * Общепит
   */
  PublicCatering = 1 << 14,
  /**
   * Гараж
   */
  Garage = 1 << 15,
  /**
   * Производство
   */
  Manufacture = 1 << 16,
  /**
   * Автосервис
   */
  AutoService = 1 << 17,
  /**
   * Готовый бизнес
   */
  Business = 1 << 18,
  /**
   * Здание
   */
  Building = 1 << 19,
  /**
   * Бытовые услуги
   */
  DomesticServices = 1 << 20,
  /**
   * Коммерческая земля
   */
  CommercialLand = 1 << 21,
  /**
   * Коммерческая
   */
  Commercial = Office |
    TradeArea |
    Warehouse |
    FreeAppointmentObject |
    PublicCatering |
    Garage |
    Manufacture |
    AutoService |
    Business |
    Building |
    DomesticServices |
    CommercialLand,
  Any = Residential | Commercial,
}

export function getOfferType(category: ECategory): FOfferType {
  if (
    [
      'buildingRent',
      'buildingSale',
      'businessRent',
      'businessSale',
      'carServiceRent',
      'carServiceSale',
      'commercialLandRent',
      'commercialLandSale',
      'domesticServicesRent',
      'domesticServicesSale',
      'freeAppointmentObjectRent',
      'freeAppointmentObjectSale',
      'garageRent',
      'garageSale',
      'industryRent',
      'industrySale',
      'officeRent',
      'officeSale',
      'publicCateringRent',
      'publicCateringSale',
      'shoppingAreaRent',
      'shoppingAreaSale',
      'warehouseRent',
      'warehouseSale',
    ].includes(category)
  ) {
    if (category.startsWith('building')) {
      return FOfferType.Building;
    }

    if (category.startsWith('business')) {
      return FOfferType.Business;
    }

    if (category.startsWith('carService')) {
      return FOfferType.AutoService;
    }

    if (category.startsWith('commercialLand')) {
      return FOfferType.CommercialLand;
    }

    if (category.startsWith('domesticServices')) {
      return FOfferType.DomesticServices;
    }

    if (category.startsWith('freeAppointmentObject')) {
      return FOfferType.FreeAppointmentObject;
    }

    if (category.startsWith('garage')) {
      return FOfferType.Garage;
    }

    if (category.startsWith('industry')) {
      return FOfferType.Manufacture;
    }

    if (category.startsWith('office')) {
      return FOfferType.Office;
    }

    if (category.startsWith('publicCatering')) {
      return FOfferType.PublicCatering;
    }

    if (category.startsWith('shoppingArea')) {
      return FOfferType.TradeArea;
    }

    if (category.startsWith('warehouse')) {
      return FOfferType.Warehouse;
    }
  }

  const categoryLower = category.toLowerCase();

  if (categoryLower.includes('bed')) {
    return FOfferType.Bed;
  }

  if (categoryLower.includes('room')) {
    return FOfferType.Room;
  }

  if (categoryLower.includes('flat')) {
    if (categoryLower.includes('newbuilding')) {
      return FOfferType.FlatNew;
    }

    if (categoryLower.includes('share')) {
      return FOfferType.FlatShared;
    }

    return FOfferType.FlatOld;
  }

  if (categoryLower.includes('cottage')) {
    return FOfferType.House;
  }

  if (categoryLower.includes('house')) {
    if (categoryLower.includes('townhouse')) {
      return FOfferType.Townhouse;
    }

    if (categoryLower.includes('share')) {
      return FOfferType.HousePart;
    }

    return FOfferType.House;
  }

  if (categoryLower.includes('land')) {
    return FOfferType.Land;
  }

  return FOfferType.Unexpected;
}

export function isSuburban(offerType: FOfferType) {
  return (offerType & FOfferType.Suburban) !== 0;
}

export function isFlat(offerType: FOfferType) {
  return (offerType & FOfferType.Flat) !== 0;
}
